import { render } from "./BomHeaderActions.vue?vue&type=template&id=6fdd2f00&scoped=true"
import script from "./BomHeaderActions.vue?vue&type=script&lang=js"
export * from "./BomHeaderActions.vue?vue&type=script&lang=js"

import "./BomHeaderActions.vue?vue&type=style&index=0&id=6fdd2f00&scoped=true&lang=css"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fdd2f00"]])

export default __exports__